export const BOTTOM = "bottom";
export const LEFT = "left";
export const RIGHT = "right";
export const TOP = "top";
export const CENTER = "center";

// item/layer types used in callbacks
// collected here instead of AppConstants if they weren't constants before
export const GALLERY_ASSET = "galleryAsset";

// 👇 these used exclusively for drag and drop 👇
// draggable item types
export const ASSET_ITEM = "AssetItem";
export const GALLERY_ASSET_LIST_ITEM = "GalleryAssetListItem";
export const IMAGE_LIST_ITEM = "ImageListItem";
export const ELEMENT_LAYER_ITEM = "ElementLayerItem";
export const BLOCK_STATE_LAYER_ITEM = "BlockStateLayerItem";
export const BLOCK_LAYER_ITEM = "BlockLayerItem";
export const CANVAS_SET_BLOCK_LAYER_ITEM = "CanvasSetBlockLayerItem";
export const SITE_BLOCK_ITEM = "SiteBlockItem";
export const SITE_PAGE_ITEM = "SitePageItem";
export const SITE_PAGE_FOLDER = "PageFolder";
export const FORM_FIELD_OPTION_ITEM = "FormFieldOptionItem";
